// extracted by mini-css-extract-plugin
module.exports = {"header":"Post_header__3kNAI","post-load-error":"Post_post-load-error__2aZV6"};